import axiosInstance from '../axiosInterceptor/axiosInstance'

const removeTeamFromSeason = async (data) => {
  const { orgId, seasonTeamId } = data
  const url = `v1/orgs/${orgId}/season-teams/${seasonTeamId}`
  return axiosInstance.delete(url)
}

export default removeTeamFromSeason
